import styled, { keyframes } from "styled-components"

import { MEDIA_QUERIES } from "@constants"

const AnimationRemovingMobile = keyframes`
  0% {
    opacity: 1;
  }
  33% {
    opacity: 0.8;
    transform: translateY(5%);
  }
  100% {
    opacity: 0;
    transform: translateY(-20%);
  }
`

const AnimationRemovingDesktop = keyframes`
  0% {
    opacity: 1;
  }
  33% {
    opacity: 0.8;
    transform: translateX(5%) translateY(-1%);
  }
  100% {
    opacity: 0;
    transform: translateX(-20%) translateY(5%);
  }
`

export const QuestionCardDIV = styled.div`
  position: relative;
  background: white;
  box-shadow: 0px 3px 10px rgba(0, 38, 81, 0.05);
  border: 1px solid transparent;
  border-top: 1px solid var(--color--charcoal-200);
  padding: 3px 0;
  transition:
    background 0.4s ease-out,
    box-shadow 0.2s ease-out;
  display: flex;
  justify-content: space-between;
  align-items: stretch;

  &.is-removing {
    animation: ${AnimationRemovingMobile} 0.3s ease-out;
    z-index: 5;
  }

  ${MEDIA_QUERIES.MOUSE} {
    &:hover {
      border-color: var(--color--charcoal-500);
    }
  }

  &.is-editing {
    border-color: var(--color--cobalt-600);
  }

  // When a card is being dragged somewhere, anywhere, don't do hover stuff
  .is-dragging-question & {
    opacity: 0.8;
    
    ${MEDIA_QUERIES.MOUSE} {
      &:hover {
        border-color: var(--color--action-default);
      }
    }
  }
  // When a card is being dragged somewhere and this card is in the Library, disable pointer-events!
  .is-LIBRARY.is-dragging-question & {
    pointer-events: none;
  }

  &.is-placeholder {
    background: var(--color--cobalt-200);
    border-color: var(--color--cobalt-200);
    box-shadow: none;
    opacity: 0.1;

    > * {
      opacity: 0;
    }
  }

  &.is-dragging {
    background: var(--color--cobalt-100);
    border-color: var(--color--cobalt-400);

    .QuestionCardActionButton.drag-handle {
      opacity: 1;
    }
  }

  &.show-edit-prompt {
    background: var(--color--cobalt-100);
    border-top-color: var(--color--cobalt-600);
    border-bottom-color: var(--color--cobalt-600);
  }

  .QuestionCardContent {
    cursor: default;
    -webkit-user-select: none;
    -ms-user-select: none; 
    user-select: none; 

    ${MEDIA_QUERIES.TOUCH} {
      user-select: none;
    }
  }

  .QuestionCardContent,
  .QuestionCardInput {
    flex: 0 0 calc(100% - 80px);
    padding: 12px 0;
    font-family: var(--font-family--default);
    font-size: var(--font-size--S);
    letter-spacing: var(--letter-spacing--text);
    line-height: var(--line-height--blockquote);
    font-weight: var(--font-weight--text);
  }

  ${MEDIA_QUERIES.M} {
    grid-template-columns: 44px auto 44px;
    box-shadow: var(--elevation--XS);
    border: 1px solid var(--color--charcoal-200);
    border-radius: 4px;
    margin-bottom: 10px;

    .QuestionCardContent,
    .QuestionCardInput {
      flex: 0 0 calc(100% - 88px);
      padding: 27px 0;
    }

    &:last-of-type {
      margin-bottom: var(--spacing--S);
    }

    &.is-removing {
      animation: ${AnimationRemovingDesktop} 0.3s ease-out;
      z-index: 5;
    }

    .QuestionCardActionButton {
      opacity: 0;
      transition: 0.2s opacity;

      ${MEDIA_QUERIES.TOUCH} {
        opacity: 1;
      }
    }
    
    &:hover .QuestionCardActionButton {
      opacity: 1;
    }

    .is-dragging-question & {
      .QuestionCardActionButton {
        opacity: 0;
      }
    }
  }
`

export const QuestionCardActionsDIV = styled.div`
  flex: 0 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${MEDIA_QUERIES.M} {
    flex: 0 0 44px;
  }

  button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 32px;

    &:only-child {
      margin: auto;
    }

    .Icon {
      background: var(--color--charcoal-600);
    }

    &:hover .Icon {
      background: var(--color--charcoal-600);
    }

    &.save-button .Icon {
      background: var(--color--green-400);
    }

    &:not(.drag-handle) {
      transform: scale(0.75);

      ${MEDIA_QUERIES.M} {
        transform: scale(1);
      }
    }

    ${MEDIA_QUERIES.M} {
      width: 44px;
    }

    &.mobile-checkbox {
      position: relative;

      .Icon {
        background: var(--color--green-700);
        height: 10px;
        opacity: 0;
        position: relative;
        transition: opacity 0.1s;
        width: 10px;
        z-index: 1;
      }

      &::before {
        content: "";
        display: block;
        background: var(--color--charcoal-200);
        border: 1px solid var(--color--charcoal-300);
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        transform: translate(-50%, -50%);
        transition: all 0.2s;
      }

      &.is-in-interview {
        .Icon {
          opacity: 1;
        }

        &::before {
          background: var(--color--green-200);
          border-color: var(--color--green-200);
        }
      }
    }
  }
`
